import { render, staticRenderFns } from "./ArticleAttributeBuilder.vue?vue&type=template&id=1268aea1"
import script from "./ArticleAttributeBuilder.vue?vue&type=script&lang=js"
export * from "./ArticleAttributeBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports